module.exports = __webpack_public_path__ + "static/media/vrc-logo.faa18a76.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vrc-logo.PNG
// module id = 49
// module chunks = 8